function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import './credit-payment-options.scss';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { VOUCHER } from 'researcher/domain/transaction/payment-method';
import { T, useTranslate } from 'shared/helper/translate';
import Popover from 'researcher/components/Popover';
import { getUsdPrepaymentBalance, getUsdCreditBalance } from 'researcher/user/reducer';
import Prepayment from './Prepayment';
import Credits from './Credits';
import Voucher from './Voucher';
var CREDIT_OPTION_VOUCHER = 'voucher';
var CREDIT_OPTION_PREPAY_OR_CREDITS = 'prepay-credits';
var CreditPaymentOptions = function CreditPaymentOptions(_ref) {
  var currency = _ref.currency,
    disabled = _ref.disabled,
    originalTotal = _ref.originalTotal,
    resetVoucher = _ref.resetVoucher,
    resetPrepayment = _ref.resetPrepayment,
    resetCredits = _ref.resetCredits,
    verifyVoucher = _ref.verifyVoucher,
    setPaymentMethod = _ref.setPaymentMethod,
    total = _ref.total;
  var methods = useFormContext();
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useState = useState(CREDIT_OPTION_PREPAY_OR_CREDITS),
    _useState2 = _slicedToArray(_useState, 2),
    creditOption = _useState2[0],
    setCreditOption = _useState2[1];
  var _methods$watch = methods.watch(['creditsApplied', 'prepaymentApplied', 'prepaymentOption', 'useCredits']),
    _methods$watch2 = _slicedToArray(_methods$watch, 4),
    creditsApplied = _methods$watch2[0],
    prepaymentApplied = _methods$watch2[1],
    prepaymentOption = _methods$watch2[2],
    useCredits = _methods$watch2[3];
  var voucherAvailable = useSelector(function (_ref2) {
    var user = _ref2.user;
    return user.voucherAvailable;
  });
  var creditsAvailable = useSelector(getUsdCreditBalance);
  var usdPrepaymentBalance = useSelector(getUsdPrepaymentBalance);
  var maxAppliableCredits = Math.min(originalTotal, creditsAvailable);
  var appliableCredits = creditOption === CREDIT_OPTION_PREPAY_OR_CREDITS && useCredits === 'yes' ? Math.max(creditsApplied, Math.min(creditsAvailable, total)) : 0;
  var totalBeforePrepaymentAndCredit = total + Math.min(prepaymentApplied, usdPrepaymentBalance);
  var maximumApplicableUsdPrepaymentBalance = Math.min(totalBeforePrepaymentAndCredit, usdPrepaymentBalance);
  var maxPrepayCoversCost = totalBeforePrepaymentAndCredit === maximumApplicableUsdPrepaymentBalance;
  var updateCreditsApplied = function updateCreditsApplied(creditsApplied) {
    return methods.setValue('creditsApplied', creditsApplied);
  };
  var updatePrepaymentApplied = function updatePrepaymentApplied(prepaymentApplied) {
    return methods.setValue('prepaymentApplied', prepaymentApplied);
  };
  var prepaymentBalanceApplied = prepaymentApplied || usdPrepaymentBalance;
  var voucherEnabled = voucherAvailable && verifyVoucher;
  var handleSetCreditOption = function handleSetCreditOption(e, selectedOption) {
    e.preventDefault();
    if (creditOption === selectedOption) {
      return;
    }
    if (selectedOption === CREDIT_OPTION_VOUCHER) {
      resetPrepayment();
    }
    setCreditOption(selectedOption);
  };
  var useDifferentCreditPaymentOption = function useDifferentCreditPaymentOption(e) {
    resetVoucher();
    handleSetCreditOption(e, CREDIT_OPTION_PREPAY_OR_CREDITS);
  };
  var useVoucher = function useVoucher(voucher) {
    methods.setValue('voucherApplied', voucher);
    setPaymentMethod({
      id: VOUCHER,
      identity: CREDIT_OPTION_VOUCHER
    });
  };
  useEffect(function () {
    return function () {
      resetPrepayment();
      resetCredits();
      resetVoucher();
    };
  }, []);
  useEffect(function () {
    if (creditsApplied !== appliableCredits) {
      updateCreditsApplied(appliableCredits);
    }
  }, [total, +appliableCredits]);
  useEffect(function () {
    resetPrepayment();
  }, [useCredits]);
  if (creditsAvailable <= 0 && prepaymentBalanceApplied <= 0 && !voucherEnabled) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "prepayment-and-credits mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card mb-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-header"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(T, {
    source: "Payment options"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, voucherAvailable ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(T.md, {
    source: "enter-voucher-here",
    params: {
      Voucherhelp: function Voucherhelp() {
        return /*#__PURE__*/React.createElement(Popover, {
          content: "voucher-explanation"
        }, /*#__PURE__*/React.createElement(T, {
          source: "voucher"
        }));
      },
      Voucherlink: function Voucherlink() {
        return /*#__PURE__*/React.createElement("button", {
          "aria-label": t('here'),
          type: "button",
          className: "voucher-link",
          onClick: function onClick(e) {
            return handleSetCreditOption(e, CREDIT_OPTION_VOUCHER);
          }
        }, /*#__PURE__*/React.createElement(T, {
          source: "here"
        }));
      }
    }
  }), creditOption === CREDIT_OPTION_VOUCHER ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Voucher, {
    resetVoucher: resetVoucher,
    useVoucher: useVoucher,
    verifyVoucher: verifyVoucher
  }), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Use a different payment method instead'),
    type: "button",
    onClick: useDifferentCreditPaymentOption
  }, /*#__PURE__*/React.createElement(T, {
    source: "Use a different payment method instead"
  })))) : null) : null, creditsAvailable > 0 && creditOption === CREDIT_OPTION_PREPAY_OR_CREDITS ? /*#__PURE__*/React.createElement(Credits, {
    currency: currency,
    maxAppliableCredits: maxAppliableCredits,
    updateCreditsApplied: updateCreditsApplied,
    creditsAvailable: creditsAvailable
  }) : null, maximumApplicableUsdPrepaymentBalance > 0 && creditOption === CREDIT_OPTION_PREPAY_OR_CREDITS ? /*#__PURE__*/React.createElement(Prepayment, {
    currency: currency,
    maxPrepayCoversCost: maxPrepayCoversCost,
    maximumApplicableUsdPrepaymentBalance: maximumApplicableUsdPrepaymentBalance,
    prepaymentOption: prepaymentOption,
    updatePrepaymentApplied: updatePrepaymentApplied,
    usdPrepaymentBalance: usdPrepaymentBalance,
    resetPrepayment: resetPrepayment
  }) : null, total <= 0 ? /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Complete Order'),
    type: "submit",
    className: "btn btn-large btn-success btn-squared",
    disabled: disabled
  }, /*#__PURE__*/React.createElement(T, {
    source: "Complete Order"
  })) : null)));
};
export default CreditPaymentOptions;